import { render, staticRenderFns } from "./textContent.vue?vue&type=template&id=0e69f156&scoped=true&"
import script from "./textContent.vue?vue&type=script&lang=ts&"
export * from "./textContent.vue?vue&type=script&lang=ts&"
import style0 from "./textContent.vue?vue&type=style&index=0&id=0e69f156&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e69f156",
  null
  
)

export default component.exports